export const isProfessionRequiredByEvaluationType = (evaluationTypeValue, countryCode, evaluationTypesData) => {
  const evaluationTypes = evaluationTypesData?.[countryCode];

  const isInvalidInput =
    evaluationTypeValue === null ||
    !evaluationTypes ||
    !Number.isFinite(Number(evaluationTypeValue));

  if (isInvalidInput) {
    return true;
  }

  const value = Number(evaluationTypeValue);
  const evaluationType = evaluationTypes.find((type) => type.value === value);

  return evaluationType?.requiresProfession !== false;
};
